import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/axios';

interface ReportPayload {
    contentType: 'poll' | 'comment';
    contentId: number;
    reason: string;
    description?: string;
}

export function useReportContent() {
    return useMutation({
        mutationFn: async ({ contentType, contentId, reason, description }: ReportPayload) => {
            const endpoint =
                contentType === 'poll'
                    ? `/api/polls/${contentId}/report/`
                    : `/api/comments/${contentId}/report/`;
            const { data } = await api.post(endpoint, { reason, description });
            return data;
        },
    });
}
